import { createRef, useEffect } from "react";
import { DefaultComponentProps, Dialog, DialogContent, DialogTitle, FlexGrid, Typography } from "@albo-ui/core";
import { useAddTask } from "./hooks/useAddTask";
import TextEditor from "../../elements/DraftEditor/TextEditor";
import { TextField, Box } from "@mui/material";
import { Info } from "@mui/icons-material";
import moment from "moment";
moment.locale("es");

export type ManageTaskDialogProps = {
    open: boolean;
    item: any;
    onClose: () => void;
    onConfirm: (data: any) => void;
} & DefaultComponentProps;

export const ManageTask = ({item, open, onClose, onConfirm}: ManageTaskDialogProps) => {
    const { form, error, addDecription, onHandleChange } = useAddTask(open, item, onConfirm);
    const inputRef = createRef();

    useEffect(() => {
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const init = async () => {
        await document;
        if (document.getElementById("datePickerId")) {
            let datePickerId = document.getElementById("datePickerId");
            datePickerId["min"] = new Date().toISOString().slice(0, 16);

            var date = new Date();
            var newDate = new Date(date.setMonth(date.getMonth() + 6));
            datePickerId["max"] = new Date(newDate).toISOString().slice(0, 16);
        }
    };
    const send = (data) => {
        form["description"] = data["content"];
        return onConfirm(form);
    }

    return (
        item && (
            <Dialog onClose={onClose} open={open} style={{ minWidth: 600, maxHeight: 500 }}>
                <DialogTitle>
                    <Typography variant="h2">{item["tooltip"]}</Typography>
                </DialogTitle>

                <DialogContent style={{paddingBottom: 0}}>
                    <Box mt={1} mb={0.5}>
                        <TextField
                            id="datePickerId"
                            value={form["edate"] || ""}
                            onInput={onHandleChange.bind(this, "edate")}
                            type={"datetime-local"} label="Fecha expiración" InputLabelProps={{ shrink: true }} InputProps={{ ref: inputRef }} style={{ cursor: "pointer" }} color="secondary"
                        />
                    </Box>
                    <Info fontSize="small" color="primary" sx={{ mr: 0.5, verticalAlign: "sub" }}/>
                    <Typography variant="small" color="primary">
                        Escribe la fecha para la que debe completarse esta tarea
                    </Typography>

                    <FlexGrid container direction="column" fullWidth style={{ marginTop: 25, paddingBottom: 0 }}>
                        <TextEditor onConfirm={item["edit"] ? send :  addDecription} onCancel={onClose} value={form["description"] || item["description"]} />
                    </FlexGrid>

                    {error && <Typography variant="small" color="required">{error}</Typography>}
                </DialogContent>
            </Dialog>
        )
    );
};
